import { types, actions } from './requests'
export const GETGT2000DATA_TYPES = {
    ...types('GETGT2000DATA'),
}
export const GETGT2000DATA_ACTIONS = {
    ...actions('GETGT2000DATA'),
}
